import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNgLocaleCalendar } from './primeng-locale-calendar.model';


@Injectable()
export class PrimeNgLocaleService {

  private firstDayOfWeek: number = 1;

  constructor(
    private translate: TranslateService
  ) { }

  public getCalendarLocale(): PrimeNgLocaleCalendar {
    return new PrimeNgLocaleCalendar(
      this.firstDayOfWeek,
      this.translate.instant('calendar.day_names'),
      this.translate.instant('calendar.day_names_short'),
      this.translate.instant('calendar.day_names_min'),
      this.translate.instant('calendar.month_names'),
      this.translate.instant('calendar.month_names_short'),
      this.translate.instant('calendar.today'),
      this.translate.instant('calendar.clear')
    );
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/primeng-locale/primeng-locale.service.ts